import { render, staticRenderFns } from "./LocalizationEditorToken.vue?vue&type=template&id=2b043fda&"
import script from "./LocalizationEditorToken.vue?vue&type=script&lang=js&"
export * from "./LocalizationEditorToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports